import React, { useEffect }  from "react";
import { useNavigate } from 'react-router'
import * as jwt from '../../actions/jwt';

import { useSelector, useDispatch } from 'react-redux';
import { selectAuth, setAuth } from '../../redux/infoSlice';

export * from './signIn';
export * from './signUp';
export * from './resetPassword';
export * from './terms';
export * from './language';

export const Auth = ({children}) => {
    
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const authInfo = useSelector(selectAuth);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if(!token) {
            navigate('/auth/signin');
        }  
        else{
            const decoded = jwt.decode(token);
            if(decoded.exp && decoded.exp < Date.now() / 1000){
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('meInfo');
                localStorage.removeItem('userListViewStyle');
                localStorage.removeItem('userListFilterType');
                localStorage.removeItem('userListSearchName');

                dispatch(setAuth({accessToken: null, refreshToken: null}));

                navigate('/auth/signin');
            }
            else{
                if(!authInfo.isLoggedIn){
                    dispatch(setAuth({
                        accessToken: localStorage.getItem('access_token'),
                        refreshToken: localStorage.getItem('refresh_token'),
                    }));
                }
            }
        }      
    }, [navigate]);

    return (
        <>
            {children}
        </>
    );
};
